import React, { useState, useEffect, useContext } from "react";
// @material-ui/core components
import { makeStyles, Typography, Button, CircularProgress } from "@material-ui/core";
import Edit from "@material-ui/icons/Edit";
import MuiAlert from '@material-ui/lab/Alert';
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Table from "components/Table/Table.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import RecordsMenu from "components/Menus/RecordsMenu.js";
import SearchIcon from '@material-ui/icons/Search';
// data imports
import db from 'firebase/dbConfig'
//Router
import { Link } from 'react-router-dom'
// Context
import { UserContext } from 'context/userContext'

const useStyles = makeStyles(theme => ({
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  },
  card:{
    background: 'white',
    [theme.breakpoints.down("xs")]: {
      minWidth: '95vw',
      position: 'relative',
      right: 20,
      padding: '-15px',
    },
  },
  alert: {
    margin: 20,
    textAlign: 'justify',
  },
  icons:{
    "&:hover": {
      background: 'rgb(230, 230, 230)',
      cursor: 'pointer',
    }
  },
  linkBox:{
    marginTop: 30,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  midButton:{
    marginRight: '20px',
    marginLeft: '20px',
  },
  infoIcon: {
    marginRight: 20,
  },
  progress:{
    margin: 50,
  }
}))

const LIMIT = 100

export default function Records() {
  const classes = useStyles()
  const [fichas, setFichas] = useState([])
  const [lastVisible, setLastVisible] = useState([])
  const [disableNextButton, setDisableNextButton] = useState(false)
  let tabledData = []
  const {currentUser, userProfile, isPro, recordsCount} = useContext(UserContext)


  useEffect(() => {
    if (currentUser){
      db.collection('fichas').where('user', '==', currentUser.uid).orderBy("data", "desc").limit(LIMIT)
      .onSnapshot(snapshot => {
        const length = snapshot.docs.length
        setLastVisible(snapshot.docs[length - 1])
        setDisableNextButton(false)

        const allRecords = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        setFichas(allRecords);
      });
     }
   }, [currentUser]);

    function handleNextPage(){
      db.collection('fichas').where('user', '==', currentUser.uid).orderBy("data", "desc").startAfter(lastVisible).limit(LIMIT)
      .onSnapshot(snapshot => {
        const length = snapshot.docs.length
        if (snapshot.docs[length - 1]){
          setLastVisible(snapshot.docs[length - 1])
        } else {
          setDisableNextButton(true)
        }
        const allRecords = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setFichas(prev => [...prev, ...allRecords]);
      });
    }

    fichas.map(ficha => (
      tabledData.push(
        [ficha.data.toDate().toLocaleDateString(),
         ficha.nome,
         ficha.idade,
         <Link to={{pathname: '/new', state: {...ficha,
                                              data: ficha.data.toDate(),
                                              }}}>
            <Edit className={classes.icons} fontSize="small" color="action"/>
         </Link>,
         <RecordsMenu ficha={ficha}/>
       ])
    ))

  return (
    <div className={classes.root}>
    { !userProfile &&  ( <MuiAlert className={classes.alert} elevation={6} variant="filled" severity="info">
                    É muito importante que seu perfil seja preenchido! Clique no item "Perfil" no menu lateral.
                  </MuiAlert>
    )}
    { (!isPro && recordsCount > 5 && recordsCount < 12) &&  ( <MuiAlert className={classes.alert} elevation={6} variant="filled" severity="info">
                    Assine o Plano Pro e desfrute do uso ilimitado de todas as nossas funcionalidades.
                  </MuiAlert>
    )}
    { (!isPro && recordsCount > 14 && recordsCount < 20) &&  ( <MuiAlert className={classes.alert} elevation={6} variant="filled" severity="info">
                    Resta(m) apenas {20 - recordsCount} ficha(s) na sua cota gratuita. Assine o PRO agora para usar a ferramenta de modo ilimitado.
                  </MuiAlert>
    )}
    { (!isPro && recordsCount >= 20) &&  ( <MuiAlert className={classes.alert} elevation={6} variant="filled" severity="error">
                    Você excedeu sua cota gratuita. Assine o PRO agora para realizar atendimentos ilimitados.
                  </MuiAlert>
    )}
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card className={classes.card}>
          <CardHeader color="primary">
            <h4 className={classes.cardTitleWhite}>Minhas APAs</h4>
            <p className={classes.cardCategoryWhite}>
              Exibindo seus últimos atendimentos
            </p>
          </CardHeader>
          <CardBody>
            {fichas.length === 0 && <><MuiAlert className={classes.alert}
                                              elevation={6}
                                              variant="filled"
                                              severity="info">
                          <span className={classes.infoIcon}>ⓘ </span> Carregando
                          informações do banco de dados... Caso elas demorem ou
                          não apareçam: Verifique sua conexão e/ou se certifique que
                          você já salvou alguma ficha
                                    </MuiAlert>
                                    <CircularProgress className={classes.progress}/>
                                    </>}
            <div className={classes.linkBox}>
              <SearchIcon/>
              <Link to='/search'>
                <Typography variant="caption">Pesquisar pacientes por nome</Typography>
              </Link>
            </div>
            <Table
              tableHeaderColor="primary"
              tableHead={["Data", "Nome", "Idade", "Editar", "Opções"]}
              tableData={tabledData}
            />
          </CardBody>
        </Card>
      </GridItem>
      <Button disabled={disableNextButton} variant="outlined" style={{margin: '0 auto'}} color="primary" onClick={() => {handleNextPage()}}>VISUALIZAR PRÓXIMOS DA LISTA</Button>

    </GridContainer>

    </div>
  );
}
